module.exports = __webpack_public_path__ + "img/service-icon7.2cabaaf5.png";